import DepartmentsContainer from '../../../containers/DepartmentsContainer'

const Departments = () => {
  return (
    <DepartmentsContainer />
  )
}

export default Departments